import {Component, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-team-action',
  templateUrl: './team-action.component.html',
  styleUrls: ['./team-action.component.less'],
  standalone: true,
})
export class TeamActionComponent {
  @ViewChild('intro') intro!: ElementRef;
  show: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  @HostListener('document:scroll')
  onViewportScroll() {
    if (!isPlatformBrowser(this.platformId) || !this.intro) { return; }
    const windowHeight = window.innerHeight;
    const boundingRectFive = this.intro.nativeElement.getBoundingClientRect();

    if (boundingRectFive.top <= windowHeight - 200) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
}
